/*
Component for displaying the number of search results and buttons for sorting
*/

<template>
  <div class="result-count-container d-sm-flex justify-content-between align-items-end mt-3 pb-3 border-bottom">
    <div class="result-count-message">
      {{ isLoading ? loadingMessage:`${resultCount}
            ${countMessage}` }}
    </div>
    <div>
      <router-link
        v-if="keycloak && keycloak.authenticated && catalogAllowed"
        :to="{name: 'UploadPageDatasetDetails', query: { catalog: $route.query.catalog, locale: $route.query.locale } }"
      >
        <b-button
          variant="primary"
          class="mr-3"
        >
          {{ $t('message.datasets.createDataset') }}
        </b-button>
      </router-link>
      <b-button-group class="sort-by-container">
        <b-button
          v-for="({sort, order, text}, index) in sortOptions.slice(0, sortDropdownAfterCount)"
          :key="`sort@${index}`"
          variant="outline-primary"
          size="md"
          :class="{'sort-active': currentSort === `${sort}+${order}`}"
          @click="setSortMethod(sort, order)"
        >
          {{ text }}
        </b-button>
        <b-dropdown
          v-if="sortDropdownAfterCount < sortOptions.length"
          id="dropdown-sort"
          variant="outline-primary"
          size="md"
          right
          class="more-sort"
        >
          <b-dropdown-item
            v-for="({sort, order, text}, index) in sortOptions.slice(sortDropdownAfterCount)"
            :key="`more-sort@${index}`"
            @click="setSortMethod(sort, order)"
          >
            <span :class="{'sort-active': currentSort === `${sort}+${order}`}">
              {{ text }}
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </b-button-group>
    </div>
  </div>
</template>

<script>
import { decode } from '@/utils/jwt';

export default {
  name: 'DatasetsResultsInfo',
  props: {
    sortOptions: {
      type: Array,
      default() {
        const locale = this.$i18n.locale;
        return [
        { sort: 'modification_date', order: 'desc', text: this.$t('message.sort.lastUpdated') },
        { sort: 'relevance', order: 'desc', text: this.$t('message.sort.relevance') },
        { sort: `title.${locale}`, order: 'asc', text: this.$t('message.sort.nameAZ') },
        { sort: `title.${locale}`, order: 'desc', text: this.$t('message.sort.nameZA') },
        { sort: 'release_date', order: 'desc', text: this.$t('message.sort.lastCreated') },
        ]
      }
    },
    sortDropdownAfterCount: {
      type: Number,
      default: 2
    },
    loadingMessage: {
      type: String,
      default: "",
      required: true,
    },
    countMessage: {
      type: String,
      default: "",
      required: true,
    },
    resultCount: {
      type: Number,
      default: 0,
      required: true,
    },
    sortQuery: {
      type: String,
      default: '',
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      // Maybe refactor this as a mixin or similar? Think DRY...
      catalogAllowed: false,
      authenticated: false,
      keycloak: this.$keycloak,
    }
  },
  computed: {
    currentSort() {
      // Computes the first (primary) sort query
      // Recall that sort queries may be like 'relevance+desc, modification_date+desc, title.en+asc'
      return this.sortQuery.split(',')[0]
    }
  },
  created() {
    this.checkAuthenticated();
  },
  methods: {
    setSortMethod(method, order) {
      // eslint-disable-next-line
      this.$router.replace({ query: Object.assign({}, this.$route.query, { sort: `${method}+${order}` }) });
    },
    checkAuthenticated() {
      if (!this.$env.useAuthService || !this.$keycloak.authenticated) return;
      this.$keycloak.getRtpToken().then((rtpToken) => {
        const decodedAccessToken = decode(rtpToken.data.access_token);
        let isAuthenticated = false;
        // Go through all catalogues and look for update permission
        decodedAccessToken.authorization.permissions.forEach((permission) => {
          if (permission.scopes.find(scope => scope === 'update')) {
            if (permission.rsname.replace(`${this.$env.api.catalogBaseUrl}id/catalogue/`, '') === this.$route.query.catalog) {
              this.catalogAllowed = true;
            }
            isAuthenticated = true;
          }
        });
        this.authenticated = isAuthenticated;
      });
    },
  }
}
</script>

<style scoped lang="scss">
  @import '~@/styles/bootstrap_theme.scss';

  .result-count-container {
    .result-count-message {
      font-size: 1.2rem;
      font-weight: bold;
    }
    .sort-by-container {
      .btn {
        &.sort-active:not(:hover) {
          background-color: lighten($primary, 53%);
        }
      }
      .more-sort {
        .sort-active {
          font-weight: $font-weight-bold;
        }
      }
    }
  }
</style>
